import LoadingContent from "@/common/LoadingContent";
import { Actions as COMPANY_ACTIONS } from "@/redux/actions/companyActions";
import { Actions as EMPLOYEEACTIONS } from "@/redux/actions/employeeActions";
import { Actions as PAYMENT_ACTIONS } from "@/redux/actions/paymentActions";
import { ClipboardIcon } from "@/icons/outline";
import { addMonths, format } from "date-fns";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BillingInformation from "../company-settings/billing-tab/Billing";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const BillingInfo = ({
	userPermissions,
	org,
	businessDetails,
	advisorDetails,
	currency,
	refCode,
	employeeListLength,
	orgId,
	employeesGetListWithSalary,
	selectedPlan,
	advisorPlan,
}) => {
	const [fromDate, setFromDate] = useState(new Date(format(addMonths(new Date(), -2), "yyyy-MM-01")));
	const [toDate, setToDate] = useState(new Date(format(new Date(), "yyyy-12-31")));
	const [employees, setEmployees] = useState(employeeListLength);
	const [paymentCalculation, setPaymentCalculation] = useState();

	useEffect(() => {
		setEmployees(employeeListLength);
	}, [employeeListLength]);

	useEffect(() => {
		if (advisorPlan == "95a18556-d215-4cc7-98e6-d46a233f8ec5") {
			setPaymentCalculation((employees * selectedPlan?.price * 0.8 * 1.18).toFixed(2));
		} else {
			setPaymentCalculation((employees * selectedPlan?.price * 1.18).toFixed(2));
		}
	}, [employeeListLength, employees]);

	useEffect(() => {
		employeesGetListWithSalary({ from: format(fromDate, "yyyy-MM-dd"), to: format(toDate, "yyyy-MM-dd") });
	}, [orgId]);

	if (userPermissions === "None") return null;

	if (!org) return <LoadingContent />;

	return (
		<React.Fragment>
			<div className="content bg-white" style={{ paddingBottom: '8rem'}}>
				<BillingInformation forDashboard={false} />
				{refCode && (
					<div className="col-lg-12 col-xs-12 form-section">
						<div className={`col-xs-12 form-container`}>
							<div className="col-xs-12 pl-0">
								<h4>Payments on Account</h4>
							</div>
							<div>
								<p style={{ color: "#4d555d" }}>
									You can make a payment on account using the below bank details:
								</p>
								<p style={{ color: "#4d555d" }}>
									Account Holder: Buddy Ltd
									<br />
									IBAN: GB53MOOW00993506753612
									<br />
									BIC: MOOWGB22XXX
									<br />
									Bank Name: Moorwand Limited
									<br />
									Bank Address: Irongate House, 28-30 Dukes Place, London, EC3A 7LP
									<br />
									Bank Country: United Kingdom (GB)
								</p>
								<p style={{ color: "#4d555d" }}>
									Payment on account for{" "}
									<strong>{advisorDetails?.name ?? businessDetails?.name}</strong>
									<br />
									Use This Reference Code: <strong>{refCode}</strong>
									<button
										className="btn btn-default"
										style={{ marginLeft: 5 }}
										onClick={() => copyToClipboard(refCode)}
									>
										<ClipboardIcon style={{ height: "1em", float: "left" }} />
									</button>
								</p>
								<p style={{ color: "#4d555d" }}>
									All Payments will be automatically allocated within 24 hours of receipt
									<br />
									Payments with incorrect reference codes will, require manual intervention, and are
									subject to a 10 Credit administration fee.
								</p>
								<div>
									No. of Employees:
									<input
										type="number"
										autoComplete="off"
										defaultValue={employees}
										name="Employees"
										onChange={(e) => setEmployees(e.target.value)}
									></input>{" "}
									<br />
									{selectedPlan?.name} Plan: {currency}
									{selectedPlan?.price}
									<span className="sub-text"> per active employee</span>
									<br />
									Amount excluding Vat: {currency}
									{employees * selectedPlan?.price}
									<br />
									Monthly Payment: {currency}
									{paymentCalculation} <br />
									Minimum Payment:
									{` ${currency}${paymentCalculation < 118 ? 118 : paymentCalculation}`}
									<button
										className="btn btn-default"
										style={{ marginLeft: 5 }}
										onClick={() =>
											copyToClipboard(
												paymentCalculation < 118 ? 118 : paymentCalculation,
											)
										}
									>
										<ClipboardIcon style={{ height: "1em", float: "left" }} />
									</button>{" "}
									<br />
									When paying via bank transfer, a minimum of €118 inc VAT is applied. <br /> All
									funds are allocated as a pre-payment on your business. <br /> Once our monthly
									charge is applied, your balance will be updated to reflect the change.
								</div>
							</div>
							<div className="clearfix"></div>
						</div>
					</div>
				)}
			</div>
			<div className="clearfix" />
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	const { creditBalance, activeEmployees, creditsSpent, advisorDetails } = state.payment?.stats || {};

	const businessDetails = state?.company?.settings;

	const userPermissions = state?.permissions?.my?.permissions?.billing;
	const bundles =
		state.payment.bundles &&
		_.orderBy(
			state.payment.bundles.filter((b) => b.isPlan),
			["credits"],
			["asc"],
		);

	const currency = state.company?.settings?.currency;
	const planOptions = bundles?.map((item) => ({
		...item,
		value: item.id,
		label: `${item.name} - ${currency}${item.price}/employee/mo`,
	}));
	const selectedPlan = planOptions?.find((item) => item.value == state.company?.settings?.plan);

	const usesAdvisor =
		businessDetails?.advisor && businessDetails.paidByAdvisor && businessDetails?.advisor === advisorDetails?.id;

	return {
		bills: state.payment.credits || [],
		hasSelectedCredits: state.payment.hasSelectedCredits,
		payPeriodDetails: state.payPeriods?.periods,
		creditBalance,
		activeEmployees,
		payrollsRun: state.payPeriods?.periods?.length,
		creditsSpent: "-",
		userPermissions,
		isAdmin: state?.my?.profile?.isAdmin,
		org: state?.company?.settings.org,
		businessDetails,
		advisorDetails: usesAdvisor ? advisorDetails : {},
		currency,
		refCode: String(
			usesAdvisor ? advisorDetails?.billingReference : businessDetails?.billingReference,
		).toUpperCase(),
		orgId: state?.company?.settings?.org,
		employeeListLength: state?.employees?.employeeListWithSalary?.length,
		selectedPlan,
		advisorPlan: usesAdvisor ? advisorDetails?.plan : undefined,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getCredits: ({ before, after }) => dispatch(PAYMENT_ACTIONS.getCredits({ before, after })),
	getPaymentStats: () => dispatch(PAYMENT_ACTIONS.getPaymentStats()),
	showPricingModal: () => dispatch(PAYMENT_ACTIONS.showPricingModal(true)),
	setBillingModal: (billingModal) => dispatch(COMPANY_ACTIONS.setBillingModal(billingModal)),
	employeesGetListWithSalary: ({ from, to }) =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary(
				{
					from: from ? from : format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
					to: to ? to : format(new Date(), "yyyy-12-31"),
				},
				{ includeTax: true },
			),
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(BillingInfo);
